<div class="loader text-center">
    <img src="../../../assets/images/31.svg">
    <!-- <div class="spinner-border text-warning" role="status">
        <span class="visually-hidden">Loading...</span>
    </div> -->
</div>